var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04762 0C0.469036 0 0 0.469035 0 1.04762V12.5714C0 13.15 0.469035 13.6191 1.04762 13.6191H3.27699C3.60057 14.5346 4.47369 15.1905 5.50001 15.1905C6.52632 15.1905 7.39944 14.5346 7.72302 13.6191H20.9524C21.531 13.6191 22 13.15 22 12.5714V7.97634C22 7.73566 21.9172 7.50232 21.7653 7.31556L18.6881 3.5297C18.4891 3.28495 18.1905 3.14286 17.8751 3.14286H13.6191V1.04762C13.6191 0.469035 13.15 0 12.5714 0H1.04762Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1715 12.8333C19.1715 14.1352 18.1161 15.1905 16.8143 15.1905C15.5125 15.1905 14.4572 14.1352 14.4572 12.8333C14.4572 11.5315 15.5125 10.4762 16.8143 10.4762C18.1161 10.4762 19.1715 11.5315 19.1715 12.8333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.36fd1c70.svg";
export { ForwardRef as ReactComponent };